import { z } from 'zod'

// Option values and limits mirror the checks on public.saas_leads (0034_saas_leads.sql).

export const ORGANIZATION_TYPE_OPTIONS = [
  { value: 'asociacion', label: 'Asociación o corporación' },
  { value: 'fundacion', label: 'Fundación u ONG' },
  { value: 'club', label: 'Club deportivo, social o cultural' },
  { value: 'comunidad', label: 'Comunidad o agrupación' },
  { value: 'otro', label: 'Otra organización' },
] as const

export const MEMBERS_ESTIMATE_OPTIONS = [
  { value: '1-50', label: 'Hasta 50 miembros' },
  { value: '51-200', label: 'Entre 51 y 200' },
  { value: '201-1000', label: 'Entre 201 y 1.000' },
  { value: '1000+', label: 'Más de 1.000' },
] as const

export const leadSchema = z.object({
  fullName: z.string().trim().min(2, 'Ingresa tu nombre.').max(120, 'El nombre es demasiado largo.'),
  email: z.string().trim().max(254, 'El correo es demasiado largo.').email('Ingresa un correo válido.'),
  phone: z
    .string()
    .trim()
    .max(30, 'El teléfono es demasiado largo.')
    .regex(/^[+\d\s()-]*$/, 'Usa solo números, espacios, paréntesis o +.'),
  organizationName: z
    .string()
    .trim()
    .min(2, 'Ingresa el nombre de la organización.')
    .max(160, 'El nombre de la organización es demasiado largo.'),
  organizationType: z.enum(['asociacion', 'fundacion', 'club', 'comunidad', 'otro'], {
    errorMap: () => ({ message: 'Selecciona el tipo de organización.' }),
  }),
  membersEstimate: z.enum(['1-50', '51-200', '201-1000', '1000+'], {
    errorMap: () => ({ message: 'Selecciona la cantidad aproximada de miembros.' }),
  }),
  message: z.string().trim().max(2000, 'El mensaje no puede superar los 2.000 caracteres.'),
  consent: z.literal(true, {
    errorMap: () => ({ message: 'Debes aceptar que te contactemos para enviar la solicitud.' }),
  }),
})

export type LeadFormValues = z.infer<typeof leadSchema>
export type LeadFormField = keyof LeadFormValues
